export default __webpack_public_path__ + "static/company-mobile-app-1-5a71427d9a8f744e5408755d14a08386.png";